import axios from 'axios'

const API_PATH = 'admins/commerce_partners'

const CommercePartnersApi = {
  /**
   * Get available commerce partners.
   * Invoke `GET /admins/commerce_partners`
   * No params are needed for this (for now)
   */
  get: async () => {
    const response = axios.get(API_PATH)
    return response
  }
}

export default CommercePartnersApi
